export default __webpack_public_path__ + "83e5228b01cbdd2fe654c6515617e723.png";